import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from './firebase'; // Ensure correct Firestore initialization
import './PaymentPage.css';

const PaymentPage = () => {
  const { productId } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [feedback, setFeedback] = useState('');

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        // Reference to the products collection
        const productsCollection = collection(db, 'products');
        
        // Query the collection based on the product_id field
        const q = query(productsCollection, where('product_id', '==', productId));
        
        // Execute the query and get the documents
        const querySnapshot = await getDocs(q);
        
        if (!querySnapshot.empty) {
          // Get the product data
          const productData = querySnapshot.docs[0].data();
          setProduct(productData);
        } else {
          console.log('No such product!');
        }
      } catch (error) {
        console.error('Error fetching product or user:', error);
      }
    };

    fetchProduct();
  }, [productId]);

  const handlePay = () => {
    // Navigate to the checkout page and pass the product details, including price and account
    navigate('/checkout', { 
      state: { 
        product, 
        feedback // Pass the feedback to the checkout page
      } 
    });
  };

  if (!product) return <div>Loading ...</div>;

  return (
    <div className="payment-page">
      <h4>Connected Account ID: {product.account}</h4>
      <h4>Name: {product.name}</h4>
      <h4>Description: {product.description}</h4>
      <img src={product.photo} alt={product.name} />
      <div className="amounts">
        <h4>Amounts:</h4>
        <ul>
          <li>Amount: ${product.price}</li>
          <li>Option 1: ${product.amount1}</li>
          <li>Option 2: ${product.amount2}</li>
          <li>Option 3: ${product.amount3}</li>
          <li>Option 4: ${product.amount4}</li>
        </ul>
      </div>
      <div className="feedback">
        <h4>Feedback:</h4>
        <p><input type="text" value={feedback} onChange={(e) => setFeedback(e.target.value)} /></p>
      </div>
      <div className="questions">
        <h4>Questions:</h4>
        <ul>
          <li>Question 1: {product.question1}</li>
          <li>Question 2: {product.question2}</li>
          <li>Question 3: {product.question3}</li>
        </ul>
      </div>
      <div>
        <button onClick={handlePay}>Pay</button>
      </div>   
    </div>
  );
};

export default PaymentPage;
